module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white",
      "width": "100vw",
      "height": "100vh"
    }
  }, [_c('v-fade-transition', [(_vm.passwordPrompt) ? _c('div', {
    attrs: {
      "id": "passwordLogin"
    }
  }, [_c('div', {
    attrs: {
      "id": "passwordInnerLogin"
    }
  }, [_c('v-icon', {
    staticClass: "close-icon",
    on: {
      "click": function($event) {
        _vm.passwordPrompt = false
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "margin-top": "1rem"
    },
    attrs: {
      "label": "Password",
      "single-line": "",
      "solo": "",
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterCollections($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    ref: "enter-button",
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.enterCollections
    }
  }, [_vm._v("ENTER")]), _vm._v(" "), (_vm.isCheckingPassword) ? _c('v-progress-circular', {
    attrs: {
      "size": 50,
      "width": 7,
      "color": "black",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loginFailed) ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "1rem"
    }
  }, [_vm._v("Invalid Login")]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.greaterThanSix) ? _c('v-parallax', {
    staticClass: "top-neck",
    attrs: {
      "dark": "",
      "src": require('../assets/neck.jpg')
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "column": "",
      "justify-center": ""
    }
  }, [_c('h1', {
    ref: "title",
    staticClass: "display-2 font-weight-thin mb-3 title-text",
    attrs: {
      "offset": "20",
      "data-lax-preset": "fadeOut"
    }
  }, [_vm._v("Mar of Santa Barbara")]), _vm._v(" "), _c('v-btn', {
    ref: "collections-button",
    attrs: {
      "data-lax-preset": "fadeOut",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.passwordPrompt = true
      }
    }
  }, [_vm._v("COLLECTIONS")])], 1)], 1) : _c('div', {
    staticClass: "top-neck"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "column": "",
      "justify-center": ""
    }
  }, [_c('h1', {
    ref: "title",
    staticClass: "display-2 font-weight-thin mb-3 title-text",
    attrs: {
      "offset": "20",
      "data-lax-preset": "fadeOut"
    }
  }, [_vm._v("Mar of Santa Barbara")]), _vm._v(" "), _c('v-btn', {
    ref: "collections-button",
    attrs: {
      "data-lax-preset": "fadeOut",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.passwordPrompt = true
      }
    }
  }, [_vm._v("COLLECTIONS")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "height": "80vh",
      "background-color": "rgb(38,36,36)"
    },
    attrs: {
      "id": "enterHolder",
      "column": ""
    }
  }, [_c('div', {
    ref: "about-holder",
    staticClass: "about-holder",
    staticStyle: {
      "width": "45%",
      "height": "30%",
      "background-color": "white",
      "margin-top": "-5rem",
      "z-index": "9999"
    }
  }, [_c('p', [_vm._v("Mar jewelry has been designed and made in Santa Barbara, California for over thirty years. Winner of numerous design awards. Each piece is meticulously handmade in our studio. Mar jewelry can be found in fine galleries and museum shops throughout the United States.\"")])]), _vm._v(" "), _c('div', {
    ref: "carousel",
    staticStyle: {
      "width": "45%",
      "height": "30%",
      "background-color": "white",
      "z-index": "999"
    },
    attrs: {
      "id": "featuredCarouselContainer"
    }
  }, [_c('p', {
    attrs: {
      "id": "awardsTitle"
    }
  }, [_vm._v("Awards")]), _vm._v(" "), _c('v-carousel', {
    attrs: {
      "dark": "",
      "hide-controls": ""
    }
  }, _vm._l((_vm.$store.state.jewelry), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "dark": ""
      }
    }, [_c('div', {
      staticClass: "carousel-item-container"
    }, [_c('img', {
      staticClass: "award-image",
      attrs: {
        "src": item.imageUrl
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "award-title",
      staticStyle: {
        "margin-top": "1rem",
        "font-family": "DINPro Bold"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "award-title"
    }, [_vm._v(_vm._s(item.awardTitle))])])])
  }), 1)], 1)]), _vm._v(" "), _c('v-parallax', {
    attrs: {
      "dark": "",
      "src": require('../assets/greg-in-studio.jpg')
    }
  }), _vm._v(" "), _c('v-footer', {
    staticClass: "pa-3 footer-greg",
    staticStyle: {
      "background-color": "black",
      "height": "auto"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('div', {
    ref: "greg-info",
    staticClass: "greg-info-container",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "greg-about-image"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "0.7rem",
      "text-align": "center",
      "margin-top": "1rem"
    }
  }, [_vm._v("ALL MAR OF SANTA BARBARA DESIGNS COPYRIGHT GREG GEYER © " + _vm._s(new Date().getFullYear()))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "bottom-right-container",
    staticStyle: {
      "width": "100%",
      "padding": "1rem"
    }
  }, [_c('h1', {
    staticClass: "display-2 font-weight-thin mb-3"
  }, [_vm._v("Greg Geyer")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": "row",
      "justify-content": "space-around",
      "align-items": "center",
      "width": "10rem",
      "margin": "0 auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.toggleShowInfo('about')
      }
    }
  }, [_vm._v("ABOUT")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.toggleShowInfo('contact')
      }
    }
  }, [_vm._v("CONTACT")])], 1), _vm._v(" "), _c('v-expand-transition', [_c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInfo == 'about'),
      expression: "showInfo=='about'"
    }],
    staticStyle: {
      "color": "white",
      "width": "100%"
    }
  }, [_vm._v("\n          Greg Geyer was born in Los Angeles California and has been surrounded by art his entire life. His mother, Mar Marcotte, for whom the company is named, studied at UCLA. His father, George Geyer, is an artist and retired art professor. His grandfather, Sueo Serisawa, was a painter, and his grandmother, Mary Serisawa, an avid photographer. It was art by osmosis for Greg.\n          Mar has been making jewelry since the late 60s. As a child Greg would help her make ear wires and other simple items. Making jewelry was his summer job in high school and throughout college. Greg was an engineering major and studied architecture which, combined with his Japanese heritage, influence both his designs and how he constructs them.\n          Greg has won multiple design awards for his jewelry. You will find Greg's designs in museum gallery gift stores and finer retailers throughout the United States.\n        ")])], 1), _vm._v(" "), _c('v-expand-transition', [_c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInfo == 'contact'),
      expression: "showInfo=='contact'"
    }],
    staticStyle: {
      "text-align": "center",
      "color": "white",
      "width": "100%"
    }
  }, [_vm._v("\n          Santa Barbara, CA\n          "), _c('br'), _vm._v("telephone: 1.805.682.3600\n          "), _c('br'), _vm._v("fax 1.805.682.3602\n          "), _c('br'), _vm._v("marofsb@gmail.com\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011306ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Landing.vue
// module id = 214
// module chunks = 1